import { render, staticRenderFns } from "./SeatSelectionBox.vue?vue&type=template&id=65c46d04"
import script from "./SeatSelectionBox.vue?vue&type=script&lang=ts"
export * from "./SeatSelectionBox.vue?vue&type=script&lang=ts"
import style0 from "./SeatSelectionBox.vue?vue&type=style&index=0&id=65c46d04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports